import { render, staticRenderFns } from "./nationalVersionForm.vue?vue&type=template&id=44c83866&scoped=true"
import script from "./nationalVersionForm.vue?vue&type=script&lang=js"
export * from "./nationalVersionForm.vue?vue&type=script&lang=js"
import style0 from "./nationalVersionForm.vue?vue&type=style&index=0&id=44c83866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c83866",
  null
  
)

export default component.exports